import { triggerToSfPortal } from './sfPortalActions';
/**
 * Middleware to communicate from React application to Symfony one.
 *
 * @returns {function}
 */
export function sfPortalMiddleware({ dispatch, getState }) {
  return next => action => {
    triggerToSfPortal(
      action.type,
      (({ type, ...others }) => ({ ...others }))(action),
    );

    if (typeof action === 'function') {
      return action(dispatch, getState);
    }

    return next(action);
  };
}
